module.exports = __webpack_public_path__ + "static/media/custom-404-page.4614a052.jpg";